'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _topups = require('redux/modules/topups');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _payments = require('redux/modules/payments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopupDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    userSubscription: state.user.subscription,
    prices: state.payments.prices
  };
}, { buyTopup: _topups.buyTopup, getPrice: _payments.getPrice }, null, { withRef: true }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(TopupDialog, _React$Component);

  function TopupDialog() {
    (0, _classCallCheck3.default)(this, TopupDialog);
    return (0, _possibleConstructorReturn3.default)(this, (TopupDialog.__proto__ || (0, _getPrototypeOf2.default)(TopupDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(TopupDialog, [{
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'handlePaymentMethodSave',
    value: function handlePaymentMethodSave() {
      this.props.onCloseYes();
    }
  }, {
    key: 'handleVATCheck',
    value: function handleVATCheck() {}
  }, {
    key: 'render',
    value: function render() {
      var userSubscription = this.props.userSubscription;


      var styles = require('./ChangePaymentDetailsDialog.scss');

      var classes = (0, _classnames3.default)((0, _defineProperty3.default)({}, styles.TopupDialog, true));

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        _react2.default.createElement('div', { className: styles.SubscriptionDetails }),
        _react2.default.createElement(
          'div',
          { className: styles.PaymentBox },
          _react2.default.createElement(_components.PaymentWizard, {
            changePaymentMethodOnly: true,
            showEmailSubscribe: false,
            onVATCheck: this.handleVATCheck.bind(this),
            customerEditBehavior: 'update',
            onPaymentMethodSave: this.handlePaymentMethodSave.bind(this) })
        )
      );
    }
  }]);
  return TopupDialog;
}(_react2.default.Component)) || _class);
exports.default = TopupDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePaymentDetailsDialog/ChangePaymentDetailsDialog.jsx
// module id = 2727
// module chunks = 0